import "./style.css";
import phoneIcon from "../../../images/phone1.png";
import mapIcon from "../../../images/map1.png";
import factoryImage from "../../../images/hely.jpg";
import map from "../../../images/user/map.png";

function Contact({ address, phone }: any) {
  return (
    <div className="Contact" id="contact">
      <div
        className="contact-form"
        style={{
          background: `url(${factoryImage}) no-repeat center center fixed`,
          backgroundSize: "cover",
        }}
      >
        <div className="contact-form-container">
          <div className="contact-icons-container">
            <div className="contact-icon-block">
              <div className="contact-icon-circle">
                <img src={mapIcon as unknown as string} alt="Map Icon" />
              </div>
              <p className="contact-address-text">
                <span className="label">Cím</span>
                <br />
                <a
                  href="https://www.google.com/maps/place/Barbell+Bunker/@47.5500749,19.043564,17z/data=!3m1!4b1!4m6!3m5!1s0x4741d97f91e05a6b:0x6a346ccf6de17256!8m2!3d47.5500749!4d19.0461443!16s%2Fg%2F11kq12_ltj?authuser=0&entry=ttu&g_ep=EgoyMDI0MTEwNi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                >
                  Budapest, Bogdáni út 1, 1033
                </a>
              </p>
            </div>
            <div className="contact-icon-block">
              <div className="contact-icon-circle">
                <img src={phoneIcon as unknown as string} alt="Phone Icon" />
              </div>
              <p className="contact-phone-text">
                <span className="label">Telefon</span>
                <br />
                <a href={`tel:+${phone}`}>+{phone}</a>
              </p>
            </div>
          </div>
        </div>
        <div className="map-container">
          <div className="map" style={{ textAlign: "center" }}>
            <a
              href="https://www.google.com/maps/place/Barbell+Bunker/@47.5500749,19.043564,17z/data=!3m1!4b1!4m6!3m5!1s0x4741d97f91e05a6b:0x6a346ccf6de17256!8m2!3d47.5500749!4d19.0461443!16s%2Fg%2F11kq12_ltj?authuser=0&entry=ttu&g_ep=EgoyMDI0MTEwNi4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noreferrer"
            >
              <img
                alt=""
                src={map}
                style={{ cursor: "pointer", maxWidth: "100vw" }}
              ></img>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
